import type { TossPaymentMidVariant } from '@/types/api/payment';

/** 국내 MID용 — 보통 이것만 넣으면 됨: `REACT_APP_TOSS_CLIENT_KEY_DOMESTIC=test_ck_…` */
const clientKeyDomestic = process.env.REACT_APP_TOSS_CLIENT_KEY_DOMESTIC?.trim() ?? '';
/** 해외 MID용(선택) */
const clientKeyInternational = process.env.REACT_APP_TOSS_CLIENT_KEY_INTERNATIONAL?.trim() ?? '';
/** 단일 키 폴백(선택) */
const clientKeyFallback = process.env.REACT_APP_TOSS_CLIENT_KEY?.trim() ?? '';

/**
 * 국내(medicra04i) / 해외(medicr8cbx) 등 MID 분기: 환경변수로 클라이언트 키를 나눕니다.
 * - 기본(국내): `REACT_APP_TOSS_CLIENT_KEY_DOMESTIC` → 없으면 `REACT_APP_TOSS_CLIENT_KEY`
 * - international: `REACT_APP_TOSS_PAYMENT_VARIANT=international` + 해외 키 또는 폴백
 */
export function getTossPaymentVariant(): TossPaymentMidVariant {
    const v = (process.env.REACT_APP_TOSS_PAYMENT_VARIANT || 'domestic').toLowerCase();
    return v === 'international' ? 'international' : 'domestic';
}

export function getTossClientKey(): string | null {
    const variant = getTossPaymentVariant();
    if (variant === 'international') {
        return clientKeyInternational || clientKeyFallback || null;
    }
    return clientKeyDomestic || clientKeyFallback || null;
}

/**
 * 통화에 따라 적절한 토스 클라이언트 키 반환
 * @param currency - 결제 통화 ('KRW', 'USD', 'JPY' 등)
 * @returns 해당 통화에 맞는 클라이언트 키
 */
export function getTossClientKeyByCurrency(currency: string): string | null {
    const cur = currency.toUpperCase();
    
    // KRW는 국내 키, 그 외는 해외 키 사용
    if (cur === 'KRW') {
        return clientKeyDomestic || clientKeyFallback || null;
    }
    
    // USD, JPY, EUR 등은 해외 키 사용
    return clientKeyInternational || clientKeyFallback || clientKeyDomestic || null;
}

function envFlagTruthy(raw: string | undefined): boolean {
    const v = (raw ?? '').trim().toLowerCase();
    return v === 'true' || v === '1' || v === 'yes';
}

/**
 * `REACT_APP_DISABLE_TOSS_CHECKOUT=true` 등이면 클라이언트 키가 있어도 카드 결제창을 열지 않음(임시 비활성화).
 */
export function isTossCheckoutExplicitlyDisabled(): boolean {
    return envFlagTruthy(process.env.REACT_APP_DISABLE_TOSS_CHECKOUT);
}

/** 토스 결제창 사용 여부 — 명시 비활성화가 아니고 클라이언트 키가 있을 때만 true */
export function isTossCheckoutEnabled(): boolean {
    if (isTossCheckoutExplicitlyDisabled()) return false;
    return !!getTossClientKey();
}

